import { Box } from "@chakra-ui/react";
import dayjs from "dayjs";
import React from "react";
import DayPicker from "react-day-picker";

import { Button } from "@components/atoms";

import "react-day-picker/lib/style.css";

interface IDatePicker {
  disabledDays: (Date | { before: Date })[];
  range: { from?: Date | undefined; to?: Date | undefined };
  handleOnDayClicked: Function;
  firstAvailableDate: Date | undefined;
  isSamedayEligible?: boolean;
  canPickupToday?: boolean;
}

export const DatePicker: React.FC<IDatePicker> = ({
  disabledDays,
  range,
  handleOnDayClicked,
  firstAvailableDate,
  isSamedayEligible = false,
  canPickupToday = false,
}) => {
  const { from, to } = range || {};
  firstAvailableDate = firstAvailableDate || new Date();
  const toDate = new Date();
  toDate.setFullYear(firstAvailableDate.getFullYear() + 1);
  return (
    <Box
      sx={{
        ".DayPicker-Caption": {
          textAlign: "center",
          borderBottom: "1.5px solid black",
          paddingBottom: "1rem",
        },
        ".DayPicker-NavButton--prev": {
          left: "1.5rem",
        },
        ".DayPicker": {
          margin: "auto",
        },
        ".DayPicker-Month": {
          borderCollapse: "unset",
          borderSpacing: "8px",
        },
        ".DayPicker-Day--selected": {
          backgroundColor: "black !important",
        },
        "@media screen and (min-width: 30rem)": {
          ".DayPicker-Day": {
            padding: "0.7rem",
          },
          ".DayPicker-Month": {
            borderCollapse: "unset",
            borderSpacing: "24px 14px",
          },
        },
      }}
      display="flex"
      justifyContent="center"
      flexDirection="column"
    >
      <DayPicker
        numberOfMonths={1}
        disabledDays={disabledDays}
        selectedDays={[from, { from, to }]}
        onDayClick={handleOnDayClicked}
        initialMonth={
          isSamedayEligible
            ? canPickupToday
              ? dayjs().startOf("day").toDate()
              : dayjs().startOf("day").add(1, "day").toDate()
            : firstAvailableDate
        }
        toMonth={toDate}
      />
      {isSamedayEligible && (
        <Button
          sx={{
            alignSelf: "center",
            fontSize: "16px",
            fontWeight: "800",
            marginBottom: "1rem",
            maxWidth: "fit-content",
          }}
          type="button"
          onClick={() => {
            if (canPickupToday) {
              // format to resemble date picker value
              const today = dayjs()
                .hour(12)
                .minute(0)
                .second(0)
                .millisecond(0)
                .toDate();
              handleOnDayClicked(today);
            } else {
              const tomorrow = dayjs()
                .add(1, "day")
                .hour(12)
                .minute(0)
                .second(0)
                .millisecond(0)
                .toDate();
              handleOnDayClicked(tomorrow);
            }
          }}
        >
          {canPickupToday ? "PICKUP TODAY" : "PICKUP TOMORROW"}
        </Button>
      )}
    </Box>
  );
};
export default DatePicker;
